// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

// Styles
import '../styles/coloredTag.css';

export default class ColoredTag extends React.Component {
    render = () => {
        return (
            <div
                className='colored-tag'
                style={{
                    backgroundColor: this.props.backgroundColor?? 'var(--color-primary)',
                    color: this.props.color?? 'var(--color-text)',
                    overflow: 'hidden'
                }}
            >
                {this.props.label}
            </div>
        );
    }
}